import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const aiPricingRuleSchema = z.object({
  id: z.string(),
  feature: z.string(),
  modelName: z.string().default("gpt-oss:120b"),
  pricePerMInputUsd: z.number().default(0.15),
  pricePerMOutputUsd: z.number().default(0.6),
  tokensPerPoint: z.number().default(2000),
  floorPoints: z.number().default(1),
  roundingStep: z.number().default(0.5),
  dailyCap: z.number().nullable().optional(),
  enabled: z.boolean().default(true),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export class AiPricingRuleDto extends createZodDto(aiPricingRuleSchema) {}
